import styled from "styled-components";

export const OuterWrapper = styled.div({
    position: "relative",
});

export const BottomActionsWrapper = styled.div<{ isAndroid?: boolean; isIOS?: boolean }>(
    ({ theme, isAndroid, isIOS }) => ({
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "20px",
        margin: `0 ${theme.spacing.large}`,
        background: theme.colors[theme.colorMode].background_Primary,
        textAlign: "center",
        borderRadius: "32px",
        ...(isAndroid && {
            bottom: `calc(var(--sab, 0px) + 4px)`,
        }),
        ...(isIOS && {
            "@supports (bottom: env(safe-area-inset-bottom))": {
                bottom: `calc(env(safe-area-inset-bottom) + 4px)`,
            },
        }),
    }),
);

export const ImageUploaderButtonInnerRow = styled.div({
    display: "flex",
    gap: "6px",
    alignItems: "center",
    justifyContent: "center",
});
